import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ProformasService {

  readonly urlBase =  environment.rutaBase;
  
  idEmpresa_Factor:any;
  //readonly urlBase =  "http://localhost:9090";
  header : HttpHeaders;
  constructor( private http : HttpClient,  private accesoService :AccesoService) {

    this.header = this.accesoService.desencriptarTOKEN();    
    this.idEmpresa_Factor= environment.ID_EMPRESA; 

  }

  obtenerRanking(RUC_ADQ){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Top10K?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion_ADQ=${RUC_ADQ}`,{headers})
          .pipe( map (res=> {return res;}));
  }

  FiltroListadoProformas(FInicial : any ,FFinal :any , rucProv : string = '', RucAqd : string ='' , canal  :string ='' ){

    let headers = this.header;
    return this.http.get(`${this.urlBase}/Simulador?NumeroPagina=1&NumeroRegistro=100000&idEmpresa_Factor=${this.idEmpresa_Factor}&FechaInicial=${FInicial}&FechaFinal=${FFinal}&Canal=${canal}&Num_Doc_Identificacion_Prov=${rucProv}&Num_Doc_Identificacion_ADQ=${RucAqd}`,{headers});
  }

  obtenerTEM( body :any, IDEMPRESA :number){
    let headers = this.header;

    return this.http.post(`${this.urlBase}/SimuladorTEM?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }


  guardarProforma(body :any, IDEMPRESA :number){
    let headers = this.header;

    return this.http.post(`${this.urlBase}/Simulador?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  enviarProformaCliente(body: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/NotificarClienteExtranet?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });

    // let headers: HttpHeaders = new HttpHeaders();
    // headers =  headers.append('Content-Type', 'application/json');
    // headers =  headers.append('Authorization', 'SD8qVf42GHHwRF4kHC47aDqOm');
    // return this.http.post(`http://localhost:3035/api-operacion/NotificarClienteExtranet?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  guardarProformaDetalle(idProforma : number ,body :any, IDEMPRESA :number){
    let headers = this.header;

    return this.http.post(`${this.urlBase}/SimuladorDetalle/${idProforma}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  factoring( body :any, IDEMPRESA :number){
    let headers = this.header;

    return this.http.post(`${this.urlBase}/SimuladorCalc?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }
  factoringResume( body :any, IDEMPRESA :number){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/CalcularComision?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }


  obtenerProforma(idProforma :number){
    let headers = this.header;

    return this.http.get(`${this.urlBase}/SimuladorxID?idEmpresa_Factor=${this.idEmpresa_Factor}&idSimulador=${idProforma}`,{headers})
            .pipe(map(res =>{  return res[0] })  );
  }

  obtenerProformaDetalle(idProforma :number){
    let headers = this.header;

    return this.http.get(`${this.urlBase}/SimuladorDetalle?idEmpresa_Factor=${this.idEmpresa_Factor}&idSimulador=${idProforma}`,{headers});
  }


}
